export const PAGE_HEADER_ID = 'page-header'
export const BOTTOM_NAV_HEIGHT_MOBILE = 48
export const BOTTOM_NAV_HEIGHT = 56
export const PANEL_TITLE_BAR_HT_MOBILE = 42
